import { parseManifest } from "@zgame/protocol";
import raw from "../manifest.json" with { type: "json" };
const parsed = parseManifest(raw);
if (!parsed)
    throw new Error("invalid snake manifest");
export const snakeManifest = parsed;
export default snakeManifest;
//# sourceMappingURL=manifest.js.map